import { getConfig } from '@thoughtspot/custom-style-service';
function colorToTint(color, tint) {
    return color + (255 - color) * tint;
}
function hexToRGB(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
        }
        : null;
}
function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function rgbToHex(rgb) {
    return `#${componentToHex(rgb.r)}${componentToHex(rgb.g)}${componentToHex(rgb.b)}`;
}
function rgbToTint(rgb, tint) {
    return {
        r: Math.round(colorToTint(rgb.r, tint / 100)),
        g: Math.round(colorToTint(rgb.g, tint / 100)),
        b: Math.round(colorToTint(rgb.b, tint / 100)),
    };
}
function colorToShade(color, shade) {
    return color * shade;
}
function rgbToShade(rgb, shade) {
    return {
        r: Math.round(colorToShade(rgb.r, 1 - shade / 100)),
        g: Math.round(colorToShade(rgb.g, 1 - shade / 100)),
        b: Math.round(colorToShade(rgb.b, 1 - shade / 100)),
    };
}
export const getExtendedPaletteColors = (colors) => {
    const COLORS_PER_ROW = 5;
    const PRIMARY_COLOR_INDEX = 2;
    const TINT_AMOUNT = 60;
    const SHADE_AMOUNT = 60;
    const rows = [];
    for (let i = 0; i < colors.length; i += COLORS_PER_ROW) {
        rows.push(colors.slice(i, i + COLORS_PER_ROW));
    }
    const extendedColors = rows
        .filter(row => hexToRGB(row[PRIMARY_COLOR_INDEX]) !== null)
        .map(row => {
        const primaryColor = row[PRIMARY_COLOR_INDEX];
        const rgb = hexToRGB(primaryColor);
        const lighterShade = rgbToHex(rgbToTint(rgb, TINT_AMOUNT));
        const darkerShade = rgbToHex(rgbToShade(rgb, SHADE_AMOUNT));
        return [lighterShade, ...row, darkerShade];
    });
    return extendedColors.flat();
};
export const getExtendedChartColorPalette = () => {
    var _a, _b, _c, _d;
    const chartColorPalettes = (_d = (_c = (_b = (_a = getConfig()) === null || _a === void 0 ? void 0 : _a.getChartColorPalettes()) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.getColors()) !== null && _d !== void 0 ? _d : [];
    if (chartColorPalettes.length === 0) {
        return [];
    }
    return getExtendedPaletteColors(chartColorPalettes);
};
//# sourceMappingURL=chart-color-palette-utils.js.map